import { chatItems, chatImg } from "@/mocks/expose";

const statusStyle: Record<string, string> = {
  已交叉验证: "bg-primary-100 text-primary-700",
  待补证: "bg-secondary-100 text-secondary-900",
  进行中: "bg-accent-100 text-accent-800",
};

export default function ChatModule() {
  return (
    <section id="chats" className="bg-background-100/60">
      <div className="mx-auto max-w-page px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-accent-700">
              <i className="ri-chat-smile-3-line text-base"></i>
              Private Chat · 私下聊天
            </p>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              一段对话里的口径，和公开说法差多远
            </h2>
          </div>
          <button
            type="button"
            className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-3.5 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700"
          >
            <i className="ri-lock-2-line text-accent-600"></i>
            匿名提交打码截图
          </button>
        </div>

        <div className="mt-6 grid gap-6 lg:grid-cols-5">
          {/* 手机 / 克制配图 */}
          <div className="lg:col-span-2">
            <div className="relative overflow-hidden rounded-lg border border-background-200/80">
              <div className="relative h-72 md:h-80">
                <img
                  src={chatImg}
                  alt="私下聊天记录解读：暗光下的手机与对话"
                  title="私下聊天 未公开信息 对话截图"
                  className="h-full w-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <div className="absolute inset-x-4 bottom-4 flex items-center justify-between rounded-md bg-background-50/95 px-3 py-2 backdrop-blur">
                  <span className="flex items-center gap-2 text-xs text-foreground-700">
                    <i className="ri-shield-keyhole-line text-accent-600"></i>
                    截图均经技术复核，未拼接
                  </span>
                  <span className="rounded bg-primary-500 px-2 py-0.5 text-[10px] font-bold text-background-50">
                    已打码
                  </span>
                </div>
              </div>
            </div>
            <p className="mt-3 rounded-lg border border-dashed border-background-300 bg-background-50/50 p-3 text-xs leading-5 text-foreground-600">
              <i className="ri-alert-line mr-1 text-accent-600"></i>
              涉及身份的信息一律打码；仅当对话与公开行为存在可核对交叉时，我们才会收录并标注验证状态。
            </p>
          </div>

          {/* 对话解读气泡流 */}
          <div className="space-y-4 lg:col-span-3">
            {chatItems.map((c) => (
              <article
                key={c.who}
                className="rounded-lg border border-background-200/80 bg-background-50 p-4 md:p-5"
              >
                <div className="flex flex-wrap items-center gap-2">
                  <span className="font-heading text-sm font-bold text-foreground-900">
                    {c.who}
                  </span>
                  <span
                    className={`ml-auto rounded px-2 py-0.5 text-[11px] font-semibold ${statusStyle[c.status]}`}
                  >
                    {c.status}
                  </span>
                </div>
                <blockquote className="mt-3 rounded-md bg-background-100 px-4 py-3 text-[15px] italic leading-7 text-foreground-800">
                  “{c.snippet}”
                </blockquote>
                <div className="mt-3 flex items-start gap-2 text-sm leading-6 text-foreground-600">
                  <i className="ri-focus-3-line mt-0.5 text-accent-600"></i>
                  <p>
                    <span className="text-foreground-800">编辑部解读：</span>
                    {c.decipher}
                  </p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}